<template>
  <div class="books__play">
    <span class="books__play-icon iconfont iaudio"></span>
  </div>
</template>
